import { Context, useContext } from 'react';

// Re-uses the .mjs-created context instance so the TS and ReScript paths
// resolve to the same StickyVisibility provider.
import { context as mjsStickyContext } from './StickyVisibilityContext.mjs';

export interface StickyVisibilityContextType {
  isStickyHidden: boolean;
  setIsStickyHidden: (value: boolean) => void;
}

const context = mjsStickyContext as Context<StickyVisibilityContextType>;

export function useStickyVisibilityContext(): StickyVisibilityContextType {
  return useContext(context);
}

export { context as StickyVisibilityContextRaw };
